export const PAGE_QUERY_PARAM_KEY = "page";
export const FILTERS_QUERY_PARAM_KEY = "filters";
export const SEARCH_QUERY_PARAM_KEY = "q";
export const SEARCH_QUERY_REF_TYPE = "refType";
